import { createReducer, on } from '@ngrx/store';
import * as SaleActions from './sales.actions';
import { Consistencies, Sale } from './sales.models';

// -----------------------------------------------------------------------------------------------------
// @ States
// -----------------------------------------------------------------------------------------------------

export interface SalesState {
    sales: Sale[];
    sale: Sale | null;
    consistencies:
        | Consistencies
        | {
              entitiesWithoutTotalGross: [];
              entitiesWithGrossMismatch: [];
          };
    isLoading: boolean;
    error: string | null;
}

// -----------------------------------------------------------------------------------------------------
// @ Initial States
// -----------------------------------------------------------------------------------------------------

export const initialSalesState: SalesState = {
    sales: [],
    sale: null,
    consistencies: {
        entitiesWithoutTotalGross: [],
        entitiesWithGrossMismatch: [],
    },
    isLoading: false,
    error: null,
};

// -----------------------------------------------------------------------------------------------------
// @ Reducers
// -----------------------------------------------------------------------------------------------------

// Sales Reducer
export const salesReducer = createReducer(
    initialSalesState,

    // On Sales Consistency
    on(
        SaleActions.validateSalesConsistencySuccess,
        (state, { consistencies }) => ({
            ...state,
            consistencies: consistencies,
            isLoading: true,
        })
    ),

    // On Load Sales
    on(SaleActions.loadSales, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SaleActions.loadSalesSuccess, (state, { sales }) => ({
        ...state,
        isLoading: false,
        sales: sales,
    })),
    on(SaleActions.loadSalesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Sale
    on(SaleActions.loadSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SaleActions.loadSaleSuccess, (state, { sale }) => ({
        ...state,
        isLoading: false,
        sale: sale,
    })),
    on(SaleActions.loadSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(SaleActions.createSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SaleActions.createSaleSuccess, (state, { sale }) => ({
        ...state,
        isLoading: false,
        sales: [...state.sales, sale],
    })),
    on(SaleActions.createSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(SaleActions.updateSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SaleActions.updateSaleSuccess, (state, { sale }) => ({
        ...state,
        isLoading: false,
        sales: state.sales.map((sale) => (sale.id === sale.id ? sale : sale)),
    })),
    on(SaleActions.updateSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(SaleActions.deleteSale, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SaleActions.deleteSaleSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        sales: state.sales.filter((r) => r.id !== id),
    })),
    on(SaleActions.deleteSaleFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
